const NODES: ReadonlyArray<readonly [number, number]> = [
  [60, 120],
  [160, 80],
  [250, 150],
  [200, 260],
  [90, 240],
  [340, 180],
  [300, 300],
  [360, 90],
];

/** Decorative knowledge-graph line art for the brand panel. */
export function GraphArt({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      <g stroke="white" strokeWidth="1" opacity="0.5">
        <path d="M60 120 L160 80 L250 150 L200 260 L90 240 Z" />
        <path d="M160 80 L200 260 M250 150 L90 240 M60 120 L200 260 M160 80 L340 180" />
        <path d="M340 180 L300 300 L200 260 M340 180 L360 90" />
      </g>
      {NODES.map(([cx, cy], i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={i % 3 === 0 ? 5 : 3}
          fill="white"
          opacity="0.85"
        />
      ))}
    </svg>
  );
}
